import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';
import { drawPath } from '@/utils/helpers/train-simulation/draw-path';

export const createRingAtlas = (size: number, strokeWidth: number): string => {
  const res = createCanvas(size * 2, size * 2);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx } = res;

  const center = size;
  const radius = size - strokeWidth;

  const path = new Path2D();
  path.arc(center, center, radius, 0, Math.PI * 2);

  drawPath(ctx, path, { stroke: '#FFFFFF', lineWidth: strokeWidth });

  return res.canvas.toDataURL();
};
